import {
    AreaSubscriptionFooterTranslation,
    AreaSubscriptionStatus,
} from '@features/area-subscription/types';
import { translateItem, translateItems } from '@utilities/hooks';

import { getTranslationOptions } from '../translation-helpers';

const notSubscribedToAreaFooterKeys = {
    footerTitle: 'AreaSubscription.SubscribeToArea.Footer.Title',
    footerSubtitle: 'AreaSubscription.SubscribeToArea.Footer.Subtitle',
    footerCta: 'AreaSubscription.SubscribeToArea.Footer.CtaLabel',
};
const userNotSubscribedToAreaFooterKeys = {
    footerTitle: 'AreaSubscription.SubscribeToArea.LoggedInUser.Footer.Title',
    footerSubtitle: 'AreaSubscription.SubscribeToArea.LoggedInUser.Footer.Subtitle',
    footerCta: 'AreaSubscription.SubscribeToArea.LoggedInUser.Footer.CtaLabel',
};

const footerTranslationKeysForStatus: {
    [K in AreaSubscriptionStatus]?: AreaSubscriptionFooterTranslation;
} = {
    notSubscribedToArea: notSubscribedToAreaFooterKeys,
    userNotSubscribedToArea: userNotSubscribedToAreaFooterKeys,
    notSubscribedToAreaNoProjectsAvailable: notSubscribedToAreaFooterKeys,
    userNotSubscribedToAreaNoProjectsAvailable: userNotSubscribedToAreaFooterKeys,
    subscribedToAreaNotSubscribedToProjects: {
        footerTitle: 'AreaSubscription.AreaSubscribed.SubscribeToProjects.Footer.Title',
        footerSubtitle: 'AreaSubscription.AreaSubscribed.SubscribeToProjects.Footer.Subtitle',
        footerCta: 'AreaSubscription.AreaSubscribed.SubscribeToProjects.Footer.CtaLabel',
    },
    subscribedToAreaSubscribedToSomeProjects: {
        footerTitle: 'AreaSubscription.AreaSubscribed.SubscribeToMoreProjects.Footer.Title',
        footerSubtitle: 'AreaSubscription.AreaSubscribed.SubscribeToMoreProjects.Footer.Subtitle',
        footerCta: 'AreaSubscription.AreaSubscribed.SubscribeToMoreProjects.Footer.CtaLabel',
    },
};

const getFooterDataForStatus = async (
    status: AreaSubscriptionStatus,
): Promise<AreaSubscriptionFooterTranslation | null> => {
    const footerKeys = footerTranslationKeysForStatus[status];
    if (!footerKeys) return null;

    const translationOptions = getTranslationOptions();
    return translateItems(footerKeys, translationOptions);
};

const translateFooterCtaLabelForStatus = async (
    status: AreaSubscriptionStatus,
): Promise<string | null> => {
    const { footerCta } = footerTranslationKeysForStatus[status] ?? {};
    if (!footerCta) return null;

    const translationOptions = getTranslationOptions();
    return translateItem(footerCta, translationOptions);
};

export { getFooterDataForStatus, translateFooterCtaLabelForStatus };
